// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2mted","noOffset":"footer-module--noOffset--1UmXm","socialIcons":"footer-module--socialIcons--HMVQZ"};